import ExpireTipComponent from './ExpireTip.vue'

const ExpireTip = {
  install(Vue) {
    Vue.component('ExpireTip', ExpireTipComponent)
  }
}

export default ExpireTip
